module.exports = __webpack_public_path__ + "static/jardins_all_logo-f2dbff249c2bac0e9f22093130115dec.png";